/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import toast from "react-hot-toast";
import { MdCloudUpload, MdCheckCircle } from "react-icons/md";
import ProductService from "../../../services/product.service";

const Products = () => {
  const navigate = useNavigate();
  const { state } = useLocation();
  const initialPackageId = state?.package?.id ? String(state.package.id) : "";

  const [packages, setPackages] = useState([]);
  const [form, setForm] = useState({
    package_id: initialPackageId,
    file: null,
  });
  const [upload, setUpload] = useState(false);
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    loadPackages();
  }, []);

  const loadPackages = async () => {
    try {
      const res = await ProductService.admin.getPackages();
      setPackages(res.packages || []);
    } catch (error) {
      toast.error("Error al cargar los BL");
    }
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      setUpload(false);
      setForm((prev) => ({ ...prev, file }));
    }
  };

  const handleUpload = async () => {
    if (!form.file) {
      toast.error("Por favor, seleccione un archivo excel para continuar");
      return;
    }

    setLoading(true);
    const toastId = toast.loading("Subiendo y procesando archivo...");
    try {
      const res = await ProductService.admin.upload({
        hasFile: true,
        package_id: form.package_id,
        file: form.file,
      });

      setUpload(true);
      setData(res.data || []);
      toast.success("Se ha subido el archivo correctamente", { id: toastId });
    } catch (error) {
      toast.dismiss(toastId);
      toast.error("Error al subir el archivo");
    } finally {
      setLoading(false);
    }
  };

  const handleSave = async () => {
    if (!form.package_id) {
      toast.error("Por favor, seleccione un BL para continuar");
      return;
    }

    if (!upload) {
      toast.error("Por favor, suba un archivo excel para continuar");
      return;
    }

    setLoading(true);
    const toastId = toast.loading("Guardando contenido...");
    try {
      await ProductService.admin.save({
        hasFile: true,
        package_id: form.package_id,
        file: form.file,
      });

      toast.success("Se ha cargado el archivo correctamente", { id: toastId });
      navigate("/", { replace: true });
    } catch (error) {
      toast.dismiss(toastId);
      toast.error("Error al guardar el contenido");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="flex flex-col h-[calc(100vh-5rem)] overflow-y-auto px-4 py-6 md:px-8">
      {/* SELECTOR DE BL */}
      <div className="max-w-md mx-auto w-full mb-6">
        <select
          value={form.package_id}
          onChange={(e) =>
            setForm((prev) => ({ ...prev, package_id: e.target.value }))
          }
          className="w-full bg-white border border-gray-200 rounded-xl px-4 py-3 shadow-sm outline-none focus:ring-2 focus:ring-[#1D3B8B] text-gray-800 font-medium"
        >
          <option value="">Seleccionar BL</option>
          {packages.map((item) => (
            <option key={item.id} value={item.id}>
              {item.number}
            </option>
          ))}
        </select>
      </div>

      {/* CONTENEDOR BLANCO SUBIDA Y TABLA */}
      <div className="bg-white rounded-2xl shadow-sm border border-gray-100 flex-1 flex flex-col overflow-hidden mb-6">
        <div className="p-6 md:p-8 flex flex-col items-center">
          <h2 className="text-lg font-bold text-gray-800 uppercase mb-6">
            Subir listado excel
          </h2>

          <div className="flex w-full max-w-md shadow-sm rounded-xl overflow-hidden border border-gray-200 bg-gray-50 mb-6">
            <label className="flex-1 flex items-center justify-between px-4 py-3 cursor-pointer hover:bg-gray-100 transition-colors">
              <span className="text-sm text-gray-600 truncate flex items-center gap-2 font-medium">
                {form.file ? (
                  <>
                    <MdCheckCircle
                      className="text-green-500 shrink-0"
                      size={20}
                    />
                    <span className="text-gray-900 font-semibold">
                      {form.file.name}
                    </span>
                  </>
                ) : (
                  <>
                    <MdCloudUpload
                      className="text-gray-400 shrink-0"
                      size={20}
                    />
                    <span>Seleccionar archivo Excel</span>
                  </>
                )}
              </span>
              <input
                type="file"
                accept=".xlsx, .xls, .csv"
                onChange={handleFileChange}
                className="hidden"
              />
            </label>
            <button
              type="button"
              onClick={handleUpload}
              disabled={loading}
              className="bg-[#1D3B8B] text-white px-6 font-bold hover:bg-[#152a66] transition-colors disabled:opacity-70"
            >
              Subir
            </button>
          </div>
        </div>

        {/* TABLA HORIZONTAL DE PRODUCTOS */}
        <div className="flex-1 overflow-x-auto border-t border-gray-100">
          <table className="w-text-sm text-left text-gray-600 whitespace-nowrap min-w-full">
            <thead className="text-xs text-gray-500 uppercase bg-gray-50/80 border-b border-gray-100">
              <tr>
                <th className="px-4 py-3 font-semibold">CTN</th>
                <th className="px-4 py-3 font-semibold min-w-[200px]">
                  PRODUCTO
                </th>
                <th className="px-4 py-3 font-semibold">QTY</th>
                <th className="px-4 py-3 font-semibold">KG</th>
                <th className="px-4 py-3 font-semibold">CM</th>
                <th className="px-4 py-3 font-semibold">CM</th>
                <th className="px-4 py-3 font-semibold">CM</th>
                <th className="px-4 py-3 font-semibold">M3</th>
                <th className="px-4 py-3 font-semibold">KG FINAL</th>
                <th className="px-4 py-3 font-semibold min-w-[200px]">
                  CLIENTE
                </th>
                <th className="px-4 py-3 font-semibold min-w-[200px]">
                  TRACKING
                </th>
                <th className="px-4 py-3 font-semibold">FECHA</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-gray-50">
              {data.length === 0 ? (
                <tr>
                  <td
                    colSpan="12"
                    className="px-6 py-12 text-center text-gray-400"
                  >
                    No se han encontrado registros
                  </td>
                </tr>
              ) : (
                data.map((item, index) => (
                  <tr
                    key={index}
                    className="hover:bg-gray-50/50 transition-colors"
                  >
                    <td className="px-4 py-3">{item.ctn}</td>
                    <td className="px-4 py-3 font-medium text-gray-900">
                      {item.name}
                    </td>
                    <td className="px-4 py-3">{item.qty}</td>
                    <td className="px-4 py-3">{item.kg}</td>
                    <td className="px-4 py-3">{item.cm_1}</td>
                    <td className="px-4 py-3">{item.cm_2}</td>
                    <td className="px-4 py-3">{item.cm_3}</td>
                    <td className="px-4 py-3">{item.m3}</td>
                    <td className="px-4 py-3">{item.final_kg}</td>
                    <td className="px-4 py-3">{item.client_code}</td>
                    <td className="px-4 py-3">{item.tracking}</td>
                    <td className="px-4 py-3">{item.date}</td>
                  </tr>
                ))
              )}
            </tbody>
          </table>
        </div>
      </div>

      {/* BOTONES INFERIORES */}
      <div className="flex border-t border-gray-100 bg-white rounded-2xl shadow-sm overflow-hidden">
        <button
          type="button"
          onClick={() => navigate(-1)}
          disabled={loading}
          className="flex-1 py-4 font-bold text-gray-600 uppercase hover:bg-gray-100 transition-colors border-r border-gray-100"
        >
          Cerrar
        </button>
        <button
          type="button"
          onClick={handleSave}
          disabled={loading}
          className="flex-1 py-4 font-bold text-white bg-[#1D3B8B] uppercase hover:bg-[#152a66] transition-colors disabled:opacity-70"
        >
          {loading ? "Guardando..." : "Guardar"}
        </button>
      </div>
    </div>
  );
};

export default Products;
